"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Slide_1 = __importDefault(require("@mui/material/Slide"));
const react_1 = __importDefault(require("react"));
const Dialog_1 = __importDefault(require("../Dialog/Dialog"));
const DialogTransition = (props) => react_1.default.createElement(Slide_1.default, { direction: "up", ...props });
const BottomSheetDialog = ({ isDesktop, ...props }) => {
    return isDesktop ? (react_1.default.createElement(Dialog_1.default, { ...props, "data-testId": "bottom-sheet-dialog-desktop" })) : (react_1.default.createElement(Dialog_1.default, { fullScreen: true, fullWidth: true, TransitionComponent: DialogTransition, ...props, "data-testId": "bottom-sheet-dialog-mobile" }));
};
exports.default = BottomSheetDialog;
